/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Menu_CloseInputs */

const en_landing_menu_close = /** @type {(inputs: Landing_Menu_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Close menu`)
};

const pl_landing_menu_close = /** @type {(inputs: Landing_Menu_CloseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zamknij menu`)
};

/**
* | output |
* | --- |
* | "Close menu" |
*
* @param {Landing_Menu_CloseInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_menu_close = /** @type {((inputs?: Landing_Menu_CloseInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Menu_CloseInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_menu_close(inputs)
	return en_landing_menu_close(inputs)
});